import { ModalContainer } from './ModalStyles.styles';
import SecondaryButton from '../Buttons/SecondaryButton/SecondaryButton.component';
import PropTypes from 'prop-types';
import React from 'react';
import { FaTimes } from 'react-icons/fa';

// Pop up modal
const Modal = ({ children, onClose, showClose = 'true' }) => {
  return (
    <ModalContainer>
      <div className="modal swing-in-top-fwd">
        <div className="topClose">
          <button
            type="button"
            className="closeButton"
            onClick={onClose}
            aria-label="Close modal"
          >
            <FaTimes />
          </button>
        </div>
        <div className="content">
          {children}
          {showClose === 'true' && (
            <div className="buttonGroup" style={{ justifyContent: 'center' }}>
              <SecondaryButton span="Close" functionName={onClose} />
            </div>
          )}
        </div>
      </div>
    </ModalContainer>
  );
};
Modal.propTypes = {
  onClose: PropTypes.func,
  children: PropTypes.node,
  showClose: PropTypes.bool,
};

export default Modal;
